// @ts-nocheck
import ga from "@store/Framework/Common/GoogleAnalytics";
import { TrackEventBaseParameters } from "@store/Framework/Common/GoogleAnalytics/trackers/trackEvent";

/* ---------------------------------------------------------------------------------------------------- */
// Toolkit Custom Event
/* ---------------------------------------------------------------------------------------------------- */

export interface TrackSearchFilteredParameters extends TrackEventBaseParameters<"filter_type", "filter_name"> {}

const trackSearchFiltered = (parameters: TrackSearchFilteredParameters, options?: Toolkit.GoogleAnalytics.Options) => {
    return ga.track.event({ action: "search_filtered", ...parameters }, options);
};

export default trackSearchFiltered;
